import { Spinner } from '@wend/ui';

/**
 * Shown while the app is deciding whether the refresh cookie yields a session.
 * It is deliberately quiet: this state usually lasts a few hundred milliseconds
 * and a large spinner would read as a failure.
 */
export function FullPageLoader({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="relative grid min-h-dvh place-items-center bg-ink text-text">
      <div className="wend-ambient" aria-hidden="true" />
      <div className="relative z-10 flex flex-col items-center gap-3 text-muted">
        <Spinner size="lg" label={label} />
        <p className="font-mono text-[0.7rem] uppercase tracking-[0.14em] text-muted">{label}</p>
      </div>
    </div>
  );
}
